const zoomElements = document.querySelectorAll('.text-image-extended__image--zoom');

if (zoomElements.length > 0) {
    zoomElements.forEach((element) => {
        element.addEventListener('click', function (event) {
            event.preventDefault();
            simulateImageClick(this);
        });
    });
}

function simulateImageClick(zoomElement) {
    const container = zoomElement.closest('.text-with-image-extended');
    if (container) {
        const imageLink = container.querySelector('.image--lightbox');
        if (imageLink) {
            imageLink.click();
        }
    }
}
